module.exports = "/components/components/browseGroupsButtonsComponent-db9bb2.html";